import React from 'react';
import loadable from '@loadable/component';

import query from './query.graphql';
import { Props } from './editorial-content-listing';

const EditorialContentListing = loadable(() =>
  import(/* webpackChunkName: "article" */ './editorial-content-listing')
);

const EditorialContentListingPage = (props: Props) => (
  <EditorialContentListing {...props} />
);

EditorialContentListingPage.graphQL = query;

EditorialContentListingPage.variables = () => ({});

export default EditorialContentListingPage;
